/*
 * @Author: zerui.yao
 * @Date: 2022-12-06 15:22:52
 * @LastEditors: zerui.yao
 * @LastEditTime: 2024-05-09 13:42:05
 * @FilePath: /fed-authority/src/api/authority/index.js
 * @Description:
 */
import db from '@/api/dbAuthority';

const model = {
  // 应用列表
  getAppList(param) {
    return db.post('/mdm/app/search', param);
  },
  // 我的权限列表
  getMyPermission(param) {
    return db.post('/permission/relate/myPermission/page', param);
  },
  // 下属权限列表
  getLowerPermission(param) {
    return db.post('/permission/relate/myLowerPermission/page', param);
  },
  // 权限点列表
  getPermissionPoint(param) {
    return db.post('/permission/listPermission', param);
  },
  // 权限详情
  getPermissionPointDetail(param) {
    return db.get(`/permission/get/${param.id}`, param);
  },
  // 人员权限列表
  getPermissionList(param) {
    return db.post('/permission/relate/pagePermission', param);
  },
  // 回收人员权限
  recyclePermission(param) {
    return db.post(`/permission/relate/recycleUser/${param.id}?type=0`, param);
  },
  // 回收下属权限
  recyclePermission2(param) {
    return db.post(`/permission/relate/recycleUser/${param.id}?type=1`, param);
  },
  // 创建权限点
  addPermissionPoint(param) {
    return db.post('/permission/add', param, {
      reqValid: true,
    });
  },
  // 修改权限点
  updatePermissionPoint(param) {
    return db.post('/permission/update', param);
  },
  // 删除权限点
  deletePermissionPoint(param) {
    return db.delete(`/permission/delete/${param.id}`, param);
  },
  // 权限点用户列表
  getPermissionUsers(param) {
    return db.post('/permission/user/list', param);
  },
  // 权限点用户添加
  addPermissionUsers(param) {
    return db.post('/permission/relate/add/user', param, {
      reqValid: true,
    });
  },
  // 权限点用户有效期修改
  updateUserPeriod(param) {
    return db.post('/permission/relate/updatePeriod', param);
  },
  // 修改权限点状态
  updatePermissionStatus(param) {
    return db.post('/permission/updateStatus', param);
  },
  // 创建角色
  addRole(param) {
    return db.post('/role/createRole', param, {
      reqValid: true,
    });
  },
  // 更新角色
  updateRole(param) {
    return db.post('/role/updateRole', param);
  },
  // 删除角色
  deleteRole(param) {
    return db.post('/role/deleteRoleById', param);
  },
  // 角色列表
  getRoleList(param) {
    return db.post('/role/listRoles', param);
  },
  // 角色用户
  getRoleUsers(param) {
    return db.post('/role/relate/pageUser', param);
  },
  // 角色关联权限点
  getRolePermission(param) {
    return db.post('/role/relate/pageRolePermission', param);
  },
  // 角色添加权限
  addRolePermission(param) {
    return db.post('/role/relate/add/permission', param);
  },
  // 角色删除权限
  deleteRolePermission(param) {
    return db.post('/role/relate/delete/permission', param);
  },
  // 角色添加用户
  addRoleUser(param) {
    return db.post('/role/relate/add/user', param, {
      reqValid: true,
    });
  },
  // 更新角色用户有效期
  updateRoleUserPeriod(param) {
    return db.post('/role/relate/update/user', param);
  },
  // 角色删除用户（0904弃用）
  // deleteRoleUser(param) {
  //   return db.post('/role/relate/delete/user?type=0', param);
  // },
  // 角色删除用户
  deleteRoleUser(param) {
    return db.post('/role/relate/recycle/user?type=0', param);
  },
  recycleRoleUser(param) {
    return db.post('/role/relate/recycle/user?type=1', param);
  },
  // 我的角色
  getMyRole(param) {
    return db.post('/role/relate/myRole/page', param);
  },
  // 人员角色
  getUserRole(param) {
    return db.post('/role/relate/pageRole', param);
  },
  // 我的下级角色
  getLowerRole(param) {
    return db.post('/role/relate/myLowerRole/page', param);
  },
  // 获取菜单列表
  getMenuList(param) {
    return db.get('/menu/list', param);
  },
  // 添加菜单
  addMenuItem(param) {
    return db.post('/menu/create', param);
  },
  // 编辑菜单
  editMenuItem(param) {
    return db.post('/menu/modify', param);
  },
  // 删除菜单
  deleteMenuItem(menuId) {
    return db.post(`/menu/delete/${menuId}`);
  },
  // 批量删除
  deleteMenuItems(param) {
    return db.post('menu/delete', param);
  },
  // 导出人员权限
  exportAllPermission(param) {
    return db.post('/permission/relate/permission/export', param, {
      responseType: 'blob',
    });
  },
  // 导出我的下级权限
  exportLowerPermission(param) {
    return db.post('/permission/relate/myLowerPermission/export', param, {
      responseType: 'blob',
    });
  },
  // 导出我的下级角色
  exportLowerRole(param) {
    return db.post('/role/relate/myLowerRole/export', param, {
      responseType: 'blob',
    });
  },
  // 当前用户是否是有下属
  checkIsManager(param) {
    return db.get('/permission/relate/menuCheck', param);
  },
  // 获取申请周期
  getApplyTime(param) {
    return db.get('/permissionApply/applyTime', param);
  },
  // 通过clientId获取应用
  getAppByClientId(param) {
    return db.get('/permissionApply/apps', param);
  },
  // 提交权限申请
  submitPermissionApply(param) {
    return db.post('/permissionApply/applyPermissionAndRole', param);
  },
  // 获取审查任务
  getTaskDetail(param) {
    return db.get('/permissionTask/onGoingTask?taskType=review', param);
  },
  // 获取审查任务历史
  getTaskHistory(param) {
    return db.post('/permissionTask/page', param);
  },
  // 获取审查任务历史详情
  getTaskHistoryDetail(param) {
    return db.get('/permissionTask/reviewResult', param);
  },
  // 提交审查结果
  submitTaskResult(param) {
    return db.post('/permissionTask/complete', param);
  },
  // 人员审查报告列表
  getTaskHistoryReport(param) {
    return db.post('/permissionTask/page', param);
  },
  // 公司审查报告列表
  getTaskGroupReport(param) {
    return db.post('/permissionTaskConfig/list', param);
  },
  // 公司级审查报告详情
  getTaskGroupReportDetail(param) {
    return db.get('/permissionTaskConfig/get', param);
  },
  getTaskGroupReportRecord(param) {
    return db.post('/reviewResult/page', param);
  },
  getRolePointLog(param) {
    return db.post('/permission/pagePermissionLog', param);
  },
  // 获取权限点数据范围定义
  getDataRange(param) {
    return db.post('/dataRange/list', param);
  },
  // 获取权限点数据范围选项
  getDataRangeOptions(param) {
    return db.get('/dataRange/detail/items', param);
  },
  // 下属权限-权限点 批量移除 ?type=1
  recyclePointBatch(param) {
    return db.post(
      `/permission/relate/recycleUser/batch?type=${param.type}`,
      param.selectedRowKeys
    );
  },
  // 下属权限-角色 批量移除 ?type=1
  recycleUserBatch(param) {
    return db.post(`/role/relate/recycle/user/batch?type=${param.type}`, param.selectedRowKeys);
  },
  // 获取用户信息
  getUserInfo(param) {
    return db.get('/account/get', param);
  },
   // 获取角色/权限日志
  // changeLog/permissionOrRole/page
  permissionOrRole(param) {
    return db.post('/changeLog/permissionOrRole/page', param);
  },
  // 人员日志
  personnelLog(param) {
    return db.post('/changeLog/permissionOrRoleRelated/page', param);
  },
  // 导入权限 https://gateway-frontend-external-test.ecarxgroup.com/authority-web/permission/relate/permission/import
  importPermission(param) {
    return db.post('/permission/relate/permission/import', param,{
      responseType: 'blob',
    }
  );
  },
  // 导入角色 https://gateway-frontend-external-test.ecarxgroup.com/authority-web/role/relate/role/import  
  importRole(param) {
    return db.post('/role/relate/role/import', param, {
        responseType: 'blob',
      }
  );
  },

  
};
export default model;
